export const formatPrefixDiscountCode = value => {
  return value
    .trim()
    .toUpperCase()
    .replace(/\s/g, "-");
};
